module.exports = __webpack_public_path__ + "index-default.png?9cf4e5872c70d446d5ae770d222e641a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-default.png
// module id = 130
// module chunks = 0